import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as loginReducers from '@modules/login/reducers';
import * as profileReducers from '../../../reducers/';
import { select, Store } from '@ngrx/store';
import {AdminApiService} from '@modules/super-admin/services/admin-api.service';
import * as Countries from '@modules/login/components/countries';
import { resize } from '@root/utils/resize';
import { UpdateMerchantDetail, UpdateMerchantDetailSuccess } from '@modules/profile/actions/merchant-detail.actions';
import { Subscription } from 'rxjs';
import * as merchantReducers from '@modules/profile/reducers';
import { MerchantDetailService } from '@modules/profile/services/merchant-detail.service';
import { MessengerService } from '@modules/messenger/messenger.service';
import { IMerchantComment } from '@interfaces/merchant-comment.interface';
import { AddCommentDialogComponent } from '@modules/profile/components/draft/add-comment-dialog/add-comment-dialog.component';
import { MERCHANT_COMMENT_TYPE } from '@root/resources/enums/merchant-comment-types.enum';
import { MatDialog } from '@angular/material';
import { isSetInput } from '@modules/login/services/utils';
import { isDefined } from '@angular/compiler/src/util';
import { CustomValidators } from 'ng2-validation';

@Component({
  selector: 'edex-merchant-security',
  templateUrl: './merchant-security.component.html',
  styleUrls: ['./merchant-security.component.scss']
})
export class MerchantSecurityComponent implements OnInit {

  public user$ = this.store.pipe(select(loginReducers.getUser));

  private merchantDetailSub: Subscription;
  public passwordFormGroup: FormGroup;

  public merchantDetail$ = this.store.pipe(select(merchantReducers.getMerchantDetailCollection));
  public comments: IMerchantComment[] = [];
  public status = '';

  @Input() userId: string;

  public countries = Countries.slim_2;

  public smallScreen = false;

  public co = null;
  public submitted = false;
  public success$ = this.store.pipe(select(profileReducers.getProfileCollection));
  public pending$ = this.store.pipe(select(profileReducers.getProfilePending));
  public error$ = this.store.pipe(select(profileReducers.getProfileError));
  role: string;
  public hidePassword = true;
  public hidePasswordConfirm = true;
  public password = new FormControl('', [
    Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')
  ]);
  public passwordConfirm = new FormControl('', CustomValidators.equalTo(this.password));
  merchant: any;
  constructor(
    private store: Store<loginReducers.State>,
    private merchantApiService: MerchantDetailService,
    private msgr: MessengerService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private adminApi: AdminApiService,
  ) {
  }

  ngOnInit() {
    this.passwordFormGroup = this.fb.group({
      password:this.password,
    });

    this.user$.subscribe(user => {
      if (user != null) {
        const {email} = user;
        this.passwordFormGroup.patchValue({email});
      }
    });

    this.merchantDetailSub = this.merchantDetail$.subscribe(merchantDetail => {
      if (merchantDetail) {
        const {
          merchant, firstname, lastname,  country,
          countryCode, postalCode, personalInfoStatus
        } = merchantDetail;
        const { phoneNumberCall, phoneNumberSMS} = merchantDetail.merchant;
        console.log(merchant)
        this.role =merchant.role
        this.merchant =merchant
        this.status = personalInfoStatus;
        let countryObj;
        if(country){
          countryObj =  this.countries.find(i => i.name === country);
        }else{
          countryObj ="";
        } 
       
        this.user$.subscribe((user)=>{
          if(user){
            if(user.role != 'Merchant'){
              this.passwordFormGroup.patchValue({
                email: '', 
                firstname:'', 
                lastname:'', 
                signupPhoneNumberCall:'', 
                signupPhoneNumberSMS:'', country: '',
                countryCode:'', 
                postalCode:'', 
              });
              this.passwordFormGroup.patchValue({
                email: merchant.email, firstname, lastname, signupPhoneNumberCall:phoneNumberCall, signupPhoneNumberSMS:phoneNumberSMS, country: countryObj,
                countryCode, postalCode
              });
            }
          }
        })
        this.passwordFormGroup.patchValue({
          email: merchant.email, 
          firstname :isSetInput(this.passwordFormGroup.get('firstname'), firstname), 
          lastname:isSetInput(this.passwordFormGroup.get('lastname'), lastname), 
          signupPhoneNumberCall:isSetInput(this.passwordFormGroup.get('signupPhoneNumberCall'), phoneNumberCall), 
          signupPhoneNumberSMS:isSetInput(this.passwordFormGroup.get('signupPhoneNumberSMS'), phoneNumberSMS), 
          country: countryObj,
          countryCode, 
          postalCode:isSetInput(this.passwordFormGroup.get('postalCode'), postalCode), 
        });

        if (merchantDetail.personalInfoComments) {
          this.comments = merchantDetail.personalInfoComments;
        }
        this.submitted = isDefined(merchant.email)|| isDefined(firstname)|| isDefined(lastname)|| isDefined(phoneNumberCall) || isDefined(phoneNumberSMS)||isDefined(postalCode);
      }
    });
  }
  get f() {
    return this.passwordFormGroup.controls;
  }
 
  save() {
    if(this.passwordFormGroup.valid && this.passwordConfirm.valid){
    let  body={
      signupContactName: this.merchant.contactName,
      signupCompanyName: this.merchant.companyName,
      signupPhoneNumberSMS: this.merchant.phoneNumberSMS,
      signupPhoneNumberCall: this.merchant.phoneNumberCall,
      signupEmail: this.merchant.email, 
      signupPassword: this.passwordFormGroup.value.password,
      signupContactPermission: '',
      }
      this.adminApi.updateAdmin(this.userId, body).subscribe(
          (res) => {
            this.msgr.message('Admin is updated successfully.');
            this.passwordConfirm.reset();
            this.passwordFormGroup.reset();
          },
          (err) => {
            this.msgr.error(err.error.message || 'Failed to create admin.');
          }
        );
    }
  }
  getErrorPassword() {
    return this.passwordFormGroup.get('password').hasError('pattern')
        ? 'Password must contain 8 Characters: 1 Uppercase, 1 Lowercase, 1 Number and 1 Special Character': 
        this.passwordFormGroup.get('password').hasError('required')
        ? 'Not a valid password'
        : '';
  }
  
 
}
